import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchSettings } from "../../reduxSlices/settingSlices";
import { setServiceType } from "../../reduxSlices/serviceSlice";
import axios from "axios";
import Swal from "sweetalert2";
import sectionMain from "../../assets/icons/Section_Main Icons.svg";
import cleanUp from "../../assets/icons/Section_cleanUp Icons.svg";
import { toast } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import ar from "date-fns/locale/ar";
import "./hero.css";
import DatePickerPopup from "../datePicker/DatePicker";

const Hero = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const settings = useSelector((state) => state.settings.data);
  const settingsLoading = useSelector((state) => state.settings.loading);

  const [heroData, setHeroData] = useState({
    title: "صيانة التكييفات الصحراوية",
    description:
      "نقدم أفضل خدمات الصيانة و التبريد و نسعى إلى ضمان رضا العميل بنسبة 100%",
    image: "",
    key: "Main",
  });
  const [orderNumber, setOrderNumber] = useState("");
  const [orderError, setOrderError] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [mobileNumberError, setMobileNumberError] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [inquiryPopupOpen, setInquiryPopupOpen] = useState(false);
  const [datePopupOpen, setDatePopupOpen] = useState(false);
  const [thankYouPopupOpen, setThankYouPopupOpen] = useState(false);
  const [popupData, setPopupData] = useState(null);
  const [popupLoading, setPopupLoading] = useState(false);
  const [popupError, setPopupError] = useState(null);

  // Maintenance handler
  const handleMaintenanceClick = () => {
    dispatch(setServiceType("maintenance"));

    // ✅ Wait until settings are fully loaded
    if (settingsLoading || !settings) return;

    // Check if reservations are open
    const mainSetting = settings.find((item) => item.Key === "Main");
    if (!mainSetting?.Value) {
      navigate("/eidMubarak");
      return;
    }

    // Check if notes are enabled for maintenance
    const maintenanceNotesSetting = settings.find(
      (item) => item.Key === "maintainanceNotes"
    );

    navigate(
      maintenanceNotesSetting?.Value
        ? "/maintainanceNotes"
        : "/VerifiyMobileNumber"
    );
  };

  // Clean service handler
  const handleCleanServiceClick = () => {
    dispatch(setServiceType("clean"));

    // ✅ Wait until settings are fully loaded
    if (settingsLoading || !settings) return;

    // Check if reservations are open
    const mainSetting = settings.find((item) => item.Key === "Main");
    if (!mainSetting?.Value) {
      navigate("/eidMubarak");
      return;
    }

    // Check if notes are enabled for clean
    const cleanNotesSetting = settings.find(
      (item) => item.Key === "cleanNotes"
    );

    navigate(cleanNotesSetting?.Value ? "/notes" : "/VerifiyMobileNumber");
  };

  const updateMaintenanceDate = async (newDate) => {
    if (!popupData?.RequestId) {
      toast.error("لا يوجد طلب صيانة محدد لتحديثه");
      return false;
    }

    if (!newDate || !(newDate instanceof Date) || isNaN(newDate.getTime())) {
      toast.error("يجب تحديد تاريخ صيانة صالح");
      return false;
    }

    try {
      setPopupLoading(true);

      if (popupData.MaintenanceStartDate === newDate) {
        toast.info("لم يتم تغيير تاريخ الصيانة");
        return true;
      }

      const response = await axios.put(
        "https://api.generalhome.sa/api/maintenance/UpdateInfoRequest",
        {
          RequestNumber: popupData.RequestNumber,
          MaintenanceStartDate: newDate,
        },
        {
          headers: { "Content-Type": "application/json" },
          timeout: 10000,
        }
      );

      if (!response.data?.status) {
        throw new Error(response.data?.Message || "فشل في تحديث التاريخ");
      }

      setPopupData((prev) => ({
        ...prev,
        MaintenanceStartDate: newDate,
      }));

      setDatePopupOpen(false);
      setThankYouPopupOpen(true);
      return true;
    } catch (error) {
      console.error("Update failed:", error);
      const errorMessage =
        error.response?.data?.Message ||
        error.message ||
        "حدث خطأ غير متوقع أثناء التحديث";
      toast.error(errorMessage);
      return false;
    } finally {
      setPopupLoading(false);
    }
  };

  useEffect(() => {
    dispatch(fetchSettings());
  }, [dispatch]);

  const handleInquiryClick = async () => {
    if (!orderNumber.trim()) {
      setOrderError("يرجى إدخال رقم الطلب");
      return;
    }
    if (!/^\d+$/.test(orderNumber)) {
      setOrderError("رقم الطلب يجب أن يحتوي على أرقام فقط");
      return;
    }

    if (!mobileNumber.trim()) {
      setMobileNumberError("يرجى إدخال رقم الهاتف");
      return;
    }
    if (!/^\d+$/.test(mobileNumber)) {
      setMobileNumberError("رقم الهاتف يجب أن يحتوي على أرقام فقط");
      return;
    }

    setOrderError("");
    setMobileNumberError("");
    setPopupError(null);
    setPopupLoading(true);
    setPopupData(null);

    try {
      const response = await axios.get(
        `https://api.generalhome.sa/api/maintenance/GetInfoRequest?RequestNumber=${orderNumber}&PhoneNumber=${mobileNumber}`
      );

      const data = response.data;

      if (
        !data ||
        Object.keys(data).length === 0 ||
        data.message === "not found"
      ) {
        setOrderError(
          "لا يوجد طلب بهذا الرقم. يرجى التحقق والمحاولة مرة أخرى."
        );
        return;
      }

      setPopupData(data);
      setInquiryPopupOpen(true);
    } catch (error) {
      console.error("Inquiry fetch error:", error);
      setOrderError("حدث خطأ أثناء محاولة جلب البيانات. حاول مرة أخرى.");
    } finally {
      setPopupLoading(false);
    }
  };

  const moveDataToCancelled = async () => {
    try {
      Swal.fire({
        title: "هل أنت متأكد من الغاء الطلب؟",
        text: "لن تستطيع استعاده الطلب بعد الالغاء!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم، ألغِ الطلب",
        cancelButtonText: "لا، إلغاء",
        reverseButtons: true,
        backdrop: `rgba(0,0,123,0.4)`,
        customClass: {
          container: "my-swal",
        },
      }).then(async (willMove) => {
        if (willMove.value) {
          try {
            await axios.put(
              "https://api.generalhome.sa/api/maintenance/UpdateInfoRequest",
              {
                RequestNumber: popupData.RequestNumber,
                CurrentStatusId: 6,
              }
            );
            toast.success("تم الغاء الطلب بنجاح", {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            setInquiryPopupOpen(false);
          } catch (error) {
            console.error("Error moving request:", error);
            toast.error("حدث خطأ أثناء محاولة إلغاء الطلب");
          }
        } else if (willMove.dismiss === Swal.DismissReason.cancel) {
          Swal.fire({
            title: "تم الإلغاء",
            text: "لم يتم إلغاء الطلب",
            icon: "info",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "حسناً",
          });
        }
      });
    } catch (error) {
      console.error("Error parsing data:", error);
    }
  };

  const handleEditDateClick = () => {
    setInquiryPopupOpen(false);
    setDatePopupOpen(true);
  };

  const handleBackToInquiry = () => {
    setDatePopupOpen(false);
    setInquiryPopupOpen(true);
  };

  const closeAllPopups = () => {
    setInquiryPopupOpen(false);
    setDatePopupOpen(false);
    setThankYouPopupOpen(false);
  };

  registerLocale("ar", ar);

  useEffect(() => {
    const fetchHeroData = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await axios.get(
          "https://api.generalhome.sa/api/Themes/GetSlider/main"
        );
        if (response.data) {
          setHeroData((prev) => ({
            ...prev,
            title: response.data.text1 || prev.title,
            description: response.data.text2 || prev.description,
            note: response.data.note || prev.note,
            image: response.data.image || prev.image,
            key: response.data.Key || prev.key,
          }));
        }
      } catch (error) {
        console.error("Error fetching hero data:", error);
        setError("Failed to load hero content. Showing default content.");
      } finally {
        setLoading(false);
      }
    };

    fetchHeroData();
  }, []);

  return (
    <section
      className="hero"
      style={{
        backgroundImage: heroData.image ? `url(${heroData.image})` : "none",
        backgroundSize: "cover",
      }}
    >
      <div className="overlay"></div>
      <div className="hero-container container">
        <div className="hero-right">
          <div className="text-box">
            {error && <div className="error-notice">{error}</div>}
            <h2>{heroData.title}</h2>
            <p>{heroData.description}</p>
          </div>
          <div className="services-card">
            <div className="service-card" onClick={handleMaintenanceClick}>
              <div className="icon-box">
                <img src={sectionMain} alt="sectionMain" />
              </div>
              <div className="text-wrapper">
                <h4>خدمة صيانة</h4>
              </div>
            </div>
            <div className="service-card" onClick={handleCleanServiceClick}>
              <div className="icon-box">
                <img src={cleanUp} alt="sectionMain" />
              </div>
              <div className="text-wrapper">
                <h4>خدمة تنظيف</h4>
                <p>تغيير قش كرتون</p>
              </div>
            </div>
          </div>
        </div>
        <div className="hero-left">
          <h4>استعلام</h4>
          <p>الاستعلام عن الطلبات التي تم تقديمها</p>
          <ul className="styled-list">
            <li>
              <label>رقم الطلب</label>
              <input
                type="text"
                placeholder="#2345678"
                value={orderNumber}
                onChange={(e) => {
                  setOrderNumber(e.target.value);
                  if (orderError) setOrderError("");
                }}
              />
              {orderError && <p className="input-error">{orderError}</p>}
            </li>
            <li>
              <label>رقم الهاتف</label>
              <input
                type="text"
                placeholder="567891234"
                value={mobileNumber}
                onChange={(e) => {
                  setMobileNumber(e.target.value);
                  if (mobileNumber) setMobileNumberError("");
                }}
              />
              {mobileNumberError && (
                <p className="input-error">{mobileNumberError}</p>
              )}
            </li>
          </ul>
          <button onClick={handleInquiryClick}>استعلام</button>
        </div>

        {/* Inquiry Details Popup */}
        {inquiryPopupOpen && (
          <div className="popup-overlay" onClick={closeAllPopups}>
            <div
              className="popup-content slide-in"
              onClick={(e) => e.stopPropagation()}
            >
              {popupLoading ? (
                <p>جاري تحميل البيانات...</p>
              ) : popupError ? (
                <p className="error">{popupError}</p>
              ) : popupData ? (
                <div className="inquery-container">
                  <div className="inquery-content">
                    <div className="inquery-box">
                      <div className="svg-box">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="147"
                          height="146"
                          viewBox="0 0 147 146"
                          fill="none"
                        >
                          <path
                            d="M48.4316 28.6646H93.8073V38.0526H48.4316V28.6646ZM48.4316 55.2653H69.8655V64.6533H48.4316V55.2653ZM48.4316 81.8657H69.8655V91.2537H48.4316V81.8657ZM48.4316 108.597H57.5588V117.724H48.4316V108.597ZM63.9447 108.597H73.0721V117.724H63.9447V108.597ZM79.4578 108.597H88.5852V117.724H79.4578V108.597ZM94.9709 108.597H104.098V117.724H94.9709V108.597Z"
                            fill="#0D9AE1"
                          />
                          <path
                            d="M128.039 121.762L116.387 103.567C120.874 99.8406 123.997 94.7773 125.265 88.9882C126.773 82.1154 125.512 75.0671 121.715 69.1427C119.728 66.0391 117.16 63.4545 114.188 61.4646V25.4993C114.188 20.4228 110.057 16.292 104.993 16.292L30.9756 15.9397C30.9694 15.9397 30.9645 15.938 30.9583 15.938C30.9528 15.938 30.9481 15.9397 30.9426 15.9397L30.5827 15.938L30.5826 15.9787C22.7187 16.1999 18.5859 22.9544 18.5859 29.6635V32.6112H37.4351L37.4181 121.726C37.4181 126.802 41.5476 130.933 46.6241 130.933H104.979C110.057 130.933 114.188 126.802 114.188 121.726V114.72L121.414 126.004L128.039 121.762ZM116.753 72.3207V72.3221C119.698 76.9208 120.676 82.3902 119.507 87.7259C118.345 93.0333 115.19 97.571 110.63 100.517L109.763 101.02C106.825 102.72 103.641 103.611 100.471 103.762C100.384 103.766 100.296 103.767 100.209 103.769C99.6886 103.788 99.1694 103.785 98.6516 103.763C98.4426 103.754 98.2336 103.736 98.0246 103.72C97.6237 103.691 97.2233 103.655 96.8254 103.602C96.4795 103.555 96.1341 103.492 95.7884 103.427C95.5119 103.375 95.2341 103.329 94.9599 103.266C94.5449 103.171 94.1389 103.054 93.7338 102.934C93.5099 102.868 93.2831 102.812 93.0614 102.738C92.6664 102.607 92.283 102.451 91.8989 102.297C91.6699 102.205 91.4367 102.125 91.2111 102.025C90.8727 101.874 90.5479 101.7 90.2194 101.532C89.9617 101.401 89.6984 101.281 89.4458 101.138C89.1794 100.987 88.9277 100.814 88.6688 100.652C88.3726 100.466 88.0707 100.29 87.7834 100.089C87.5974 99.9582 87.4251 99.8087 87.2437 99.6717C86.9031 99.4149 86.5586 99.1644 86.2327 98.8847C86.1444 98.8088 86.0654 98.7221 85.9783 98.6447C84.6012 97.4215 83.3598 96.0016 82.318 94.3743C81.9445 93.7908 81.6007 93.1889 81.2878 92.5708C81.2502 92.4966 81.2227 92.4191 81.1859 92.3448C77.2915 84.4164 78.9884 74.89 85.1862 68.7858C85.2162 68.7562 85.2424 68.7233 85.2727 68.6939C85.672 68.3055 86.101 67.9409 86.5367 67.5822C86.6343 67.5017 86.7226 67.4126 86.8222 67.3337C87.3633 66.9045 87.9256 66.5028 88.5072 66.1302C89.315 65.6143 90.1577 65.155 91.029 64.7555C91.5112 64.5343 92.0115 64.3768 92.5052 64.1952C92.8941 64.0517 93.2748 63.8799 93.6705 63.7608C94.2066 63.5999 94.7544 63.5021 95.2992 63.3863C95.6725 63.3069 96.0401 63.2012 96.4171 63.1433C96.9303 63.0643 97.4486 63.0434 97.9654 63.0038C98.3897 62.9716 98.8113 62.9184 99.2381 62.913C100.093 62.9015 100.949 62.9342 101.801 63.0307C101.839 63.0351 101.877 63.0447 101.915 63.0492C102.744 63.1481 103.568 63.3018 104.384 63.503C104.519 63.536 104.651 63.576 104.785 63.6114C105.581 63.825 106.371 64.0765 107.145 64.3885C107.175 64.4003 107.205 64.4104 107.234 64.4224C108.105 64.7775 108.951 65.1914 109.766 65.661L110.06 65.8307C112.73 67.4315 115.025 69.6227 116.753 72.3207ZM24.9305 26.7155C25.6618 24.3053 27.3975 21.8452 30.9378 21.8351L30.9814 21.8353C34.5202 21.8464 36.2554 24.3059 36.9863 26.7155H24.9305ZM108.292 121.726C108.292 123.552 106.807 125.038 104.979 125.038H46.6241C44.7991 125.038 43.3137 123.552 43.3137 121.726L43.3306 32.6111H43.3309V29.6634C43.3309 26.9257 42.6144 24.1972 41.2696 21.8843L104.979 22.1875C106.807 22.1875 108.292 23.6729 108.292 25.4995V58.5149C108.251 58.5003 108.209 58.493 108.168 58.4785C107.389 58.2099 106.593 57.9803 105.783 57.7829C105.632 57.7457 105.484 57.6951 105.332 57.6606C105.278 57.6484 105.228 57.6297 105.175 57.6181C104.296 57.4261 103.408 57.2786 102.514 57.176C102.399 57.1628 102.284 57.1638 102.169 57.1521C101.344 57.0674 100.52 57.0176 99.6981 57.0109C99.447 57.0092 99.1971 57.0274 98.9459 57.0328C98.2522 57.047 97.5609 57.08 96.8729 57.149C96.5933 57.1772 96.3164 57.2188 96.0379 57.256C95.3796 57.3427 94.725 57.4546 94.0754 57.5916C93.7862 57.653 93.4991 57.7192 93.2118 57.7905C92.5752 57.9497 91.9448 58.1331 91.3222 58.3401C91.0372 58.4338 90.7525 58.5233 90.47 58.6271C89.8333 58.8619 89.2086 59.1312 88.5882 59.4166C88.3363 59.5321 88.0806 59.6335 87.8314 59.7573C86.9797 60.182 86.1419 60.6442 85.3292 61.1646C84.5934 61.6358 83.881 62.1426 83.1945 62.6833C82.5157 63.2179 81.8635 63.7856 81.2402 64.3841C77.5182 67.96 74.9336 72.5535 73.8044 77.7082C72.2974 84.581 73.5583 91.6293 77.3524 97.5536C77.8016 98.255 78.2826 98.9231 78.7845 99.5672C78.9592 99.7916 79.1496 99.9989 79.3305 100.217C79.6693 100.624 80.0102 101.028 80.3691 101.41C80.6026 101.659 80.8477 101.893 81.0899 102.132C81.4213 102.458 81.7554 102.78 82.1014 103.086C82.37 103.322 82.6436 103.553 82.9218 103.778C83.2684 104.061 83.6223 104.334 83.9831 104.598C84.2688 104.807 84.5554 105.014 84.8495 105.212C85.2457 105.478 85.6508 105.726 86.0594 105.969C86.3295 106.129 86.5951 106.296 86.8711 106.447C87.4425 106.76 88.0261 107.045 88.6172 107.313C88.7432 107.37 88.8633 107.438 88.9904 107.493C89.7441 107.821 90.5127 108.109 91.2918 108.365C91.4179 108.407 91.5481 108.438 91.675 108.477C92.3271 108.681 92.9868 108.86 93.6528 109.012C93.735 109.031 93.8132 109.06 93.8958 109.078C94.0269 109.107 94.1592 109.116 94.2906 109.143C94.9317 109.273 95.5763 109.378 96.2262 109.46C96.5116 109.497 96.796 109.536 97.0815 109.563C97.6676 109.617 98.2559 109.644 98.8462 109.658C99.093 109.665 99.3406 109.699 99.587 109.699C99.7187 109.699 99.848 109.672 99.9796 109.671C100.848 109.655 101.717 109.588 102.585 109.485C102.984 109.438 103.381 109.394 103.777 109.329C104.645 109.186 105.505 108.999 106.354 108.769C106.813 108.645 107.264 108.498 107.716 108.349C107.907 108.286 108.102 108.239 108.292 108.172V121.726H108.292Z"
                            fill="#132239"
                          />
                        </svg>
                      </div>
                      <div className="inquery-headline">
                        <h2>استعلام عن طلب</h2>
                        <h5
                          className={
                            popupData.CurrentStatus === "طلبات جديده"
                              ? "newReq"
                              : popupData.CurrentStatus ===
                                "الطلبات التي تم الموافقه عليها"
                              ? "approvedReq"
                              : popupData.CurrentStatus === "الطلبات المرفوضه"
                              ? "rejectedReq"
                              : popupData.CurrentStatus ===
                                "المواعيد التي تم جدولتها"
                              ? "inProgress"
                              : popupData.CurrentStatus ===
                                "المواعيد التي تم إلغائها"
                              ? "rejectedReq"
                              : "maintainceDone"
                          }
                        >
                          {popupData.RequestNumber}
                        </h5>
                      </div>
                    </div>
                    <div className="inquery-box">
                      <div className="order-info">
                        <div className="order-info-box request-status">
                          <h5>حالة الطلب</h5>
                          {popupData.CurrentStatus === "طلبات جديده" ? (
                            <p className="newReq">جديد</p>
                          ) : popupData.CurrentStatus ===
                            "الطلبات التي تم الموافقه عليها" ? (
                            <p className="approvedReq">تحت المراجعه</p>
                          ) : popupData.CurrentStatus === "الطلبات المرفوضه" ? (
                            <p className="rejectedReq">مرفوض</p>
                          ) : popupData.CurrentStatus ===
                            "المواعيد التي تم جدولتها" ? (
                            <p className="inProgress">جاري التنفيذ</p>
                          ) : popupData.CurrentStatus ===
                            "المواعيد التي تم إلغائها" ? (
                            <p className="rejectedReq">تم إلغاء الطلب</p>
                          ) : (
                            <p className="maintainceDone">تم تنفيذ الطلب</p>
                          )}
                        </div>
                        <div className="order-info-box">
                          <h5>تاريخ الحجز</h5>
                          <p>{popupData.SubmissionDate}</p>
                        </div>
                        <div className="order-info-box">
                          <h5>تاريخ الصيانة</h5>
                          <p>{popupData.MaintenanceStartDate}</p>
                        </div>
                        <div className="order-info-box">
                          <h5>الفني المسؤول</h5>
                          <p>{popupData.TechnicianName}</p>
                        </div>
                      </div>
                    </div>
                    <div className="inquery-box">
                      <div className="order-info">
                        <div className="order-info-box">
                          <h5>اسم العميل</h5>
                          <p>{popupData.CustomerName}</p>
                        </div>
                        <div className="order-info-box">
                          <h5>رقم الهاتف</h5>
                          <p>{popupData.PhoneNumber}</p>
                        </div>
                        <div className="order-info-box">
                          <h5>المدينة</h5>
                          <p>{popupData.City}</p>
                        </div>
                        <div className="order-info-box">
                          <h5>المنطقة</h5>
                          <p>{popupData.Region}</p>
                        </div>
                      </div>
                    </div>
                    <div className="inquery-box">
                      <div className="order-info">
                        <div className="order-info-box">
                          <h5>نوع المكيف</h5>
                          <p>{popupData.ACType}</p>
                        </div>
                        <div className="order-info-box">
                          <h5>ملاحظات </h5>
                          <p>{popupData.ErrorType}</p>
                        </div>
                        <div className="order-info-box">
                          <h5>حالة الضمان</h5>
                          <p
                            className={
                              popupData.WarrantyStatusName === "داخل الضمان"
                                ? "warranty-inside"
                                : "warranty-outside"
                            }
                          >
                            {popupData.WarrantyStatusName}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="inquery-buttons">
                    {popupData.CurrentStatus === "المواعيد التي تم جدولتها" && (
                      <>
                        <button
                          className="edit-date-btn"
                          onClick={handleEditDateClick}
                        >
                          تعديل موعد الصيانة
                        </button>
                        <button
                          className="cancel-request-btn"
                          onClick={() => moveDataToCancelled(popupData, 6)}
                        >
                          إلغاء الطلب
                        </button>
                      </>
                    )}
                    {popupData.CurrentStatus === "طلبات جديده" && (
                      <button
                        className="cancel-request-btn"
                        onClick={() => moveDataToCancelled(popupData, 6)}
                      >
                        إلغاء الطلب
                      </button>
                    )}
                    {popupData.CurrentStatus ===
                      "الطلبات التي تم الموافقه عليها" && (
                      <button
                        className="cancel-request-btn"
                        onClick={() => moveDataToCancelled(popupData, 6)}
                      >
                        إلغاء الطلب
                      </button>
                    )}
                  </div>
                </div>
              ) : (
                <p>لا توجد بيانات لعرضها.</p>
              )}
            </div>
          </div>
        )}

        {/* Date Selection Popup */}
        {datePopupOpen && (
          <div className="popup-overlay" onClick={closeAllPopups}>
            <div
              className="popup-content slide-in"
              onClick={(e) => e.stopPropagation()}
            >
              <DatePickerPopup
                updateMaintenanceDate={updateMaintenanceDate}
                onCancel={handleBackToInquiry}
                initialDate={popupData?.MaintenanceStartDate}
                disableBeforeDate={popupData?.MaintenanceStartDate}
                popupData={popupData}
              />
              <button
                className="back-button"
                onClick={handleBackToInquiry}
                style={{
                  marginTop: "20px",
                  padding: "10px 20px",
                  backgroundColor: "#f0f0f0",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                عوده
              </button>
            </div>
          </div>
        )}

        {/* Thank You Popup */}
        {thankYouPopupOpen && (
          <div className="popup-overlay" onClick={closeAllPopups}>
            <div
              className="thanks-popup-content slide-in"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="thanks-svg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="135"
                  height="130"
                  viewBox="0 0 135 130"
                  fill="none"
                >
                  <path
                    d="M0.5 65C0.5 29.1015 29.6015 0 65.5 0H69.5C105.399 0 134.5 29.1015 134.5 65C134.5 100.899 105.399 130 69.5 130H65.5C29.6015 130 0.5 100.899 0.5 65Z"
                    fill="#16A34A"
                    fill-opacity="0.16"
                  />
                  <path
                    d="M41.6958 67.8917L57.0101 81.157L92.7434 50.2046"
                    stroke="#16A34A"
                    stroke-width="6"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <p>تم تحديث موعدك بنجاح</p>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Hero;
